import template from './diversity_statistics_report_help.html';
import * as Utils from '../../../lib/savanna_utils.js';

class DiversityStatisticsReportHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class DiversityStatisticsReportHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new DiversityStatisticsReportHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'DiversityStatisticsReportHelp',
	dialog_class: DiversityStatisticsReportHelpPage,
	template: template,
	template_filename: 'translation/dialogs/diversity_statistics_report_help',
	provider: 'ps'
};
